import React from "react";
import { Outlet } from "react-router-dom";
import { useCurrentUser } from "../../hooks/currentUser";

import Breadcrumbs from "./Breadcrumbs";
import {
  Container,
  Card,
  Center,
  Title,
  Grid,
  LoadingOverlay,
} from "@mantine/core";

const SettingsPageWrapper = () => {
  const { currentUser } = useCurrentUser();
  if (!currentUser) {
    return (
      <LoadingOverlay
        visible={!currentUser}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
      />
    );
  }

  return (
    <Center style={{ minWidth: "70vw" }}>
      <Container pt="xs" ml="sm" mr="sm" style={{ width: "100%" }}>
        <Center style={{ minHeight: "60vh", width: "100%" }}>
          <Grid justify="center" align="center" style={{ width: "100%" }}>
            <Grid.Col span="auto" md={8} lg={6}>
              <Card
                shadow="sm"
                padding="lg"
                radius="md"
                withBorder
                style={{ minHeight: "400px" }}
              >
                <Card.Section withBorder inheritPadding py="xs">
                  <Breadcrumbs />
                  <Title order={1} align="center">
                    Settings
                  </Title>
                </Card.Section>

                <Card.Section inheritPadding py="xs">
                  {<Outlet />}
                </Card.Section>
              </Card>
            </Grid.Col>
          </Grid>
        </Center>
      </Container>
    </Center>
  );
};

export default () => <SettingsPageWrapper />;
